import {
  Component, EventEmitter, Input, Output,
  OnInit, OnChanges, SimpleChanges
} from '@angular/core';
import { Utils } from '@core/helper';
import { InputType } from '@core/models/enums';
import { InputParams } from '@core/models/models';
import { v4 } from 'uuid';

@Component({
  selector: 'caremoni-number-box',
  templateUrl: './number-box.component.html',
  styleUrl: './number-box.component.scss'
})
export class NumberBoxComponent implements OnInit, OnChanges {

  @Input() inputParams: InputParams = new InputParams();
  @Input() inputValue: any = null;
  @Input() canClear = false;

  @Output() onKeyUp = new EventEmitter<any>();
  @Output() onInput = new EventEmitter<any>();
  @Output() onKeyDown = new EventEmitter<any>();
  @Output() onClick = new EventEmitter<any>();
  @Output() onFocus = new EventEmitter<any>();
  @Output() onFocusOut = new EventEmitter<any>();
  @Output() inputValueChange = new EventEmitter();

  @Input() xdpad?: number = -1;
  @Input() ydpad?: number = -1;
  @Input() dpad?: number = -1;
  @Input() tabdpad?: number = -1;
  @Input() xtabdpad?: number = -1;
  @Input() ytabdpad?: number = -1;
  @Input() scaledpad?: number = -1;

  @Input() inputId: string = '';
  @Input() textCenter: boolean = false;

  showValidateErr: boolean = false;
  inputType: string = 'text';
  enterKey: number = 13;

  ngOnInit(): void {
    if (!this.inputId) {
      this.inputId = v4();
    }
    this.setInputType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputParams']) {
      this.showValidateErr = this.inputParams.isError === true;
    }
  }

  setInputType() {
    switch (this.inputParams?.type) {
      case InputType.number:
        this.inputType = 'number';
        break;
      default:
        this.inputType = 'text';
        break;
    }
  }

  onInputData(event: any) {
    this.onInput.emit(event);

    const value = event.target.value;

    if (this.inputType === 'number') {
      if (/^-?\d*$/.test(value)) {
        this.inputValue = value;
        this.inputValueChange.emit(this.inputValue);
      } else {
        const previous = this.inputValue || '';
        // setTimeout avoids freezing the iOS/iPadOS keyboard when resetting value
        setTimeout(() => { event.target.value = previous; }, 0);
      }
    } else {
      this.inputValue = value;
      this.inputValueChange.emit(this.inputValue);
    }
  }

  onKeyUps(event: any) {
    this.onKeyUp.emit(event);
  }

  onKeyDowns(event: any) {
    if (this.inputType === 'number') {
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End'];
      if (!allowedKeys.includes(event.key) && !/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    }
    this.onKeyDown.emit(event);
  }

  onClicks(event: any) {
    this.onClick.emit(event);
  }

  onFocusIn(event: any) {
    this.onFocus.emit(event);
  }

  onFocusOutInput(event: any) {
    this.onFocusOut.emit(event);
    if (this.inputType === 'number' && Utils.isNullOrEmpty(this.inputValue)) {
      this.inputValue = '0';
      event.target.value = '0';
      this.inputValueChange.emit(this.inputValue);
    }
  }

  clearText() {
    this.inputValue = null;
    this.inputValueChange.emit(null);
  }

  empty(value: any) {
    return value === null || value === undefined || value === '';
  }

  incrementValue(): void {
    const current = Number(this.inputValue) || 0;
    this.inputValue = String(current + 1);
    this.inputValueChange.emit(this.inputValue);
  }

  decrementValue(): void {
    const current = Number(this.inputValue) || 0;
    if (current <= 0) {
      this.inputValue = '0';
    } else {
      this.inputValue = String(current - 1);
    }
    this.inputValueChange.emit(this.inputValue);
  }
}